import React from 'react';
import './AboutFeatures.css';

const AboutFeatures = () => {
  return (
    <section className="about-features" id="about-features">
      <div className="about-features__container">
        <div className="about-features__grid">
          {/* Left Column: Features 1-3 */}
          <div className="about-features__col about-features__col--left">
            {/* Feature 01 */}
            <div className="about-features__item about-features__item--left">
              <div className="about-features__text">
                <h3 className="about-features__item-title">Trial With Multiple Tutors</h3>
                <p className="about-features__item-desc">
                  Try lessons with different certified tutors before choosing the one who feels right. Find a teaching style, personality, and pace that suits you or your child.
                </p>
              </div>
              <div className="about-features__badge">01</div>
            </div>

            {/* Feature 02 */}
            <div className="about-features__item about-features__item--left">
              <div className="about-features__text">
                <h3 className="about-features__item-title">Affordable Prices</h3>
                <p className="about-features__item-desc">
                  Get the best Quran education through our affordable pricing options, which offer flexible ways of learning with personal one-to-one lessons that fit into each person’s budget.
                </p>
              </div>
              <div className="about-features__badge">02</div>
            </div>

            {/* Feature 03 */}
            <div className="about-features__item about-features__item--left">
              <div className="about-features__text">
                <h3 className="about-features__item-title">Study Notes</h3>
                <p className="about-features__item-desc">
                  We support our students with study notes and materials provided by our tutors to review and practice lessons, thus improving your understanding and helping you to achieve your Quran education objectives.
                </p>
              </div>
              <div className="about-features__badge">03</div>
            </div>
          </div>

          {/* Middle Column: Arched/Capsule Image */}
          <div className="about-features__image-col">
            <div className="about-features__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/About.avif`}
                alt="Online Quran Classes For Adults"
                className="about-features__img"
              />
            </div>
          </div>

          {/* Right Column: Features 4-6 */}
          <div className="about-features__col about-features__col--right">
            {/* Feature 04 */}
            <div className="about-features__item about-features__item--right">
              <div className="about-features__badge">04</div>
              <div className="about-features__text">
                <h3 className="about-features__item-title">Learn the Holy Quran with Experts</h3>
                <p className="about-features__item-desc">
                  Get Quran learning through personal training from our professionals in reading, recitation, <a style={{ color: '#006100', textDecoration: "none", fontWeight: "bold" }} href="/online-tajweed-classes-tajweed-course/">learning Quran with tajweed</a>, <a style={{ textDecoration: "none", color: '#006100', fontWeight: "bold" }} href="/quran-memorization-classes-course/">memorization</a>, and comprehension according to your learning level.
                </p>
              </div>
            </div>

            {/* Feature 05 */}
            <div className="about-features__item about-features__item--right">
              <div className="about-features__badge">05</div>
              <div className="about-features__text">
                <h3 className="about-features__item-title">Dedicated Female Tutors for Women/Sisters</h3>
                <p className="about-features__item-desc">
                  Women can learn from dedicated and certified female tutors who will provide personalized lessons in a friendly manner according to each one’s individual needs.
                </p>
              </div>
            </div>

            {/* Feature 06 */}
            <div className="about-features__item about-features__item--right">
              <div className="about-features__badge">06</div>
              <div className="about-features__text">
                <h3 className="about-features__item-title">Entertaining Lectures</h3>
                <p className="about-features__item-desc">
                  Experience entertaining and interactive lessons from professional tutors that can help students get engaged in the learning process.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Center Bottom CTA Button */}
        <div className="about-features__cta">
          <a href="/free-trial/" className="about-features__btn">
            <span>Get Free Trial For Classes</span>
            <svg className="about-features__btn-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutFeatures;

